import api from './api';

export interface FacturaPosAtajoItem {
  accionId: string;
  tecla: string;
}

export interface FacturaPosAtajosResponse {
  usuario: string;
  atajos: FacturaPosAtajoItem[];
}

const facturaPosAtajosService = {
  getMine: async (): Promise<FacturaPosAtajosResponse> => {
    const response = await api.get<FacturaPosAtajosResponse>('/api/FacturaPosAtajos');
    const data = response.data;
    return {
      usuario: data.usuario ?? '',
      atajos: (data.atajos ?? []).map((a) => ({
        accionId: a.accionId ?? (a as { AccionId?: string }).AccionId ?? '',
        tecla: a.tecla ?? (a as { Tecla?: string }).Tecla ?? '',
      })),
    };
  },

  saveMine: async (atajos: FacturaPosAtajoItem[]): Promise<FacturaPosAtajosResponse> => {
    const response = await api.put<FacturaPosAtajosResponse>('/api/FacturaPosAtajos', {
      atajos: atajos.map((a) => ({
        accionId: a.accionId,
        tecla: a.tecla,
      })),
    });
    const data = response.data;
    return {
      usuario: data.usuario ?? '',
      atajos: (data.atajos ?? []).map((a) => ({
        accionId: a.accionId ?? '',
        tecla: a.tecla ?? '',
      })),
    };
  },
};

export default facturaPosAtajosService;
